import React, { Fragment, PureComponent } from "react";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toastService } from "../services/toastService";

import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";

interface SidebarState {
    sidebarVisible: boolean;
}

class MainLayout extends PureComponent<unknown, SidebarState> {
    state: SidebarState = {
        sidebarVisible: false,
    };

    toggleSidebar = () => {
        this.setState((prevState) => ({
            sidebarVisible: !prevState.sidebarVisible,
        }));
    };

    closeSidebar = () => {
        this.setState({ sidebarVisible: false });
    };

    render(): React.ReactNode {
        return (
            <Fragment>
                <Toast ref={(el) => toastService.setRef(el)} position="bottom-center" baseZIndex={99999} />
                <ConfirmDialog />
                <AppHeader toggleSidebar={this.toggleSidebar} />
                <div className="app-main flex min-h-screen pt-16">
                    <AppSidebar visible={this.state.sidebarVisible} closeSidebar={this.closeSidebar} />
                    <div className="app-main__outer flex-1 min-w-0 overflow-x-hidden overflow-y-auto bg-body dark:bg-neutral-950 transition-colors duration-200">
                        <div className="app-main__inner px-4 py-4 md:px-6 md:py-6 max-w-full">{(this.props as any).children}</div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default MainLayout;
